import { defineComponent, ref, watch } from '@vue/composition-api';
import { TransparentVideoPlayer } from '@ks/tvplayer';
import cookies from 'js-cookie';
import { versionCompare } from '@kibt/web-utils/version';
import { isIOS } from '@/utils/platform';
export default defineComponent({
  components: {},
  props: {
    src: {
      type: String,
      default: 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/top100/final-draw-1.mp4'
    },
    play: {
      type: Boolean,
      required: true
    }
  },
  emits: ['ended'],
  setup: function setup(props, ctx) {
    var visible = ref(true);
    var os = cookies.get('os') || '';
    var wrapperRef = ref(null);
    watch(function () {
      return wrapperRef.value;
    }, function () {
      if (wrapperRef.value) {
        initPlayer(wrapperRef.value);
      }
    });
    var player = null;

    var initPlayer = function initPlayer(wrapper) {
      player = new TransparentVideoPlayer({
        wrapper: wrapper,
        loop: false,
        ratio: window.devicePixelRatio || 1,
        videoUrl: props.src,
        useBlob: !(isIOS() && versionCompare(os, '16') <= 0)
      });
      player.addEventListener('videoEnded', function () {
        ctx.emit('ended');
        setTimeout(function () {
          var _player;

          (_player = player) === null || _player === void 0 ? void 0 : _player.loader.releaseVideo();
          visible.value = false;
        }, 1000);
      });
      watch(function () {
        return props.play;
      }, function () {
        if (props.play) {
          var _player2;

          (_player2 = player) === null || _player2 === void 0 ? void 0 : _player2.play();
        }
      }, {
        immediate: true
      });
    };

    return {
      wrapperRef: wrapperRef,
      visible: visible
    };
  }
});